import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

export default function VerifyEmailPage() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const base = (process.env.REACT_APP_API_URL || 'https://halfprice-ca-v2.onrender.com/api').replace(/\/+$/, '');
    fetch(`${base}/auth/business/verify/${token}`)
      .then(r => r.json())
      .then(data => {
        if (data.verified) {
          setStatus('success');
          setMessage(`${data.business.business_name} is now verified!`);
        } else {
          setStatus('error');
          setMessage(data.error || 'Verification failed');
        }
      })
      .catch(() => { setStatus('error'); setMessage('Something went wrong. Please try again.'); });
  }, [token]);

  return (
    <div className="container text-center" style={{ padding: '80px 20px', maxWidth: 480 }}>
      {status === 'loading' && (
        <>
          <p style={{ fontSize: 48 }}>⏳</p>
          <h2 style={{ marginTop: 16 }}>Verifying your email…</h2>
        </>
      )}
      {status === 'success' && (
        <>
          <p style={{ fontSize: 48 }}>✅</p>
          <h2 style={{ marginTop: 16, marginBottom: 8 }}>Email verified!</h2>
          <p style={{ color: 'var(--text-secondary)', marginBottom: 24 }}>{message} Your restaurant is now fully active on halfprice.ca.</p>
          <Link to="/business/dashboard" className="btn btn-primary btn-lg">Go to dashboard →</Link>
        </>
      )}
      {status === 'error' && (
        <>
          <p style={{ fontSize: 48 }}>😕</p>
          <h2 style={{ marginTop: 16, marginBottom: 8 }}>Verification failed</h2>
          <p style={{ color: 'var(--text-secondary)', marginBottom: 24 }}>{message}</p>
          <Link to="/business/dashboard" className="btn btn-primary btn-lg">Go to dashboard →</Link>
        </>
      )}
    </div>
  );
}
